// owner/ui/UnitPicker.js — «كل الوحدات» or one unit. ONE picker for every owner screen that narrows by unit (the
// overview, the bookings list); all units by default (tasks/owner-mobile-app-build.md §10: §2 decision 19, 200+ units).
// Screens show it only when the owner has more than one unit. `value` '' = all units.

import React from 'react';
import useLanguage from '../../hooks/useLanguage';
import Icon from './Icon';
import useOwnerFormat from './useOwnerFormat';

const UnitPicker = ({ units, value, onChange }) => {
  const { t } = useLanguage();
  const f = useOwnerFormat();
  return (
    <label className="o-unit-filter">
      <span className="o-visually-hidden">{t('ownerApp.common.unitFilter')}</span>
      <Icon name="units" size="sm" className="o-lead" />
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        <option value="">{`${t('ownerApp.common.allUnits')} (${f.count(units.length)})`}</option>
        {units.map((u) => <option key={u._id} value={u._id}>{`${u.name} — ${u.propertyCode || ''}`}</option>)}
      </select>
      <Icon name="chev" size="sm" className="o-trail" />
    </label>
  );
};

export default UnitPicker;
